import {
    FormControl, FormLabel,
    Icon, Stack, Select,
    ListSubheader, MenuItem, Divider,
    CircularProgress, Typography
} from '@mui/material'

import { forwardRef } from 'react'
import { createId } from '../../services/utils'

import Styles from './style'

export const SingleSelector = forwardRef((props, ref) => {
    const labelVariant = props.labelVariant || 'primary'
    const menuVariant = props.menuVariant || 'primary'
    const variant = props.variant || 'primary'

    const rootSx = {
        ...Styles.root[variant],
        ...props.sx ?? {}
    }

    const selectSx = {
        ...Styles.select[variant],
        ...props.selectSx ?? {}
    }

    const menuSx = {
        ...Styles.menu[variant],
        ...props.menuMainSx ?? {}
    }

    return (
        <FormControl sx={rootSx} size={props.size || 'small'} ref={ref}>
            {props.label && (<FormLabel variant={labelVariant}>{props.label}</FormLabel>)}
            <Select
                sx={selectSx}
                value={props.selected || ''}
                onChange={props.onSelect}
                MenuProps={{
                    PaperProps: { sx: menuSx },
                    MenuListProps: { variant: undefined }
                }}
                position={'bottom-start'}
                disabled={props.disabled || false}
            >
                {!props.loading && props.selection && props.selection.length > 0 && props.selection.map((item, index) => {
                    if (item.id === 'separator') {
                        if (item.label === '--') {
                            const createdId = createId()
                            return (<Divider key={createdId} />)
                        }
                        return (<ListSubheader variant={menuVariant} sx={props.menuCategorySx || {}} key={`list-subheader-${item.id}-${index}`}>{item.label}</ListSubheader>)
                    }
                    return (<MenuItem variant={menuVariant} sx={props.menuSx || {}} key={item.id} value={item.id}>{item.label}</MenuItem>)
                })}
                {props.loading && (
                    <MenuItem variant={menuVariant}>
                        <Stack direction={'row'} alignItems={'center'} spacing={1}>
                            <CircularProgress size={24} />
                            <Typography variant={'body2'}>{props.loadingLabel ?? 'LOADING'}</Typography>
                        </Stack>
                    </MenuItem>
                )}
            </Select>
            {(props.sublabel || props.error) && (
                <FormLabel error={props.error} variant={labelVariant}>
                    <Stack direction={'row'} alignItems={'center'}>
                        {props.error && (<Icon color={'error'} sx={{ fontSize: '18px', fontVariationSettings: "'FILL' 1" }}>error</Icon>)}
                        {props.error && props.errorLabel || props.sublabel}
                    </Stack>
                </FormLabel>
            )}
        </FormControl>
    )
})

SingleSelector.displayName = 'SingleSelector'

export default SingleSelector